import { Stack } from '@mui/material';
import { z } from 'zod';

import { Alert, api } from 'common';

import { type AsynchronousJobVariant, OptionalStringSchema, RequiredStringSchema } from './common';
import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSwitchField } from '../../../ConfigFields/Switch';

import JobKind = api.RpaJob.Kind;

export const ExportFormsVariant: AsynchronousJobVariant = {
  schema: z.object({
    jobKind: z.literal(JobKind.ExportForms),
    payload: z.object({
      previsitFormSetId: RequiredStringSchema,
      encounterEhrReferenceValue: OptionalStringSchema,
      templateIds: OptionalStringSchema,
      overrideAutoExport: z.boolean().optional().default(false),
    }),
  }),
  Config: () => {
    return (
      <Stack spacing={2}>
        <BlockValueTemplateField
          fieldName="config.payload.previsitFormSetId"
          label="Form Set Id"
          helperText="Enter the reference to the form set you wish to export e.g. `{{form.data.formSet.id}}`"
          placeholder="e.g. {{form.data.formSet.id}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.encounterEhrReferenceValue"
          label="Encounter Ehr ReferenceValue"
          helperText="Enter the reference encounter reference value you wish to export the form to e.g. `{{encounter.data.ehrReferenceValue}}`"
          placeholder="e.g. {{encounter.data.ehrReferenceValue}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.templateIds"
          label="Template Ids"
          helperText="Enter a comma delimited list of templateIds you wish to export from the form set e.g. `templateId-1,templateId-2`"
          placeholder="e.g. templateId-1,templateId-2"
        />
        <Alert variant="warning">
          Override auto export of forms job upon form completion. Auto export of the form is
          controlled by the Export via forms job toggle in the form template. If this is toggled on,
          the forms job will run even though the toggle is off in the form template. To prevent
          duplicate forms job from running, enable this toggle and disable the Export via forms job
          toggle in the form template.
        </Alert>
        <BlockSwitchField
          label="Override Auto Export"
          fieldName="config.payload.overrideAutoExport"
        />
      </Stack>
    );
  },
};
